import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import WorkSpace from 'modules/space_control/store/models/WorkSpace'

class WorkSpaces extends Collection<WorkSpace> {
  get indexes() {
    return ['work_area_id']
  }

  model() {
    return WorkSpace
  }

  forWorkAreaId(workAreaId: number): WorkSpace[] {
    return this.filter({ work_area_id: workAreaId })
  }
}

const singleton: WorkSpaces = new WorkSpaces()

export default singleton

const { provider: WorkSpacesProvider, hook: useWorkSpaces } = createCollectionContext<
  WorkSpace,
  WorkSpaces
>()

export { WorkSpacesProvider }
